import React from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Text } from "../../components/user/Text";
import { FeatureSection } from "../../components/user/FeatureSection";
import { ResponsiveContainer } from "../../components/user/ResponsiveContainer";
import { Image } from "../../components/user/Image";

export const WhyChooseUs = () => {
  return (
    <Element
      id="why_choose_us_container"
      canvas
      is={Container}
      className="feature-section"
      padding="80px 20px"
      background="#ffffff"
      margin="0"
      borderRadius={0}
      width="100%"
      height="auto"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        text="Why Choose Us?"
        fontSize={42}
        color="#1a1a2e"
        fontWeight="bold"
        textAlign="center"
        margin="0 0 50px 0"
        padding="0"
      />

      <Element
        id="features_grid_container"
        canvas
        is={ResponsiveContainer}
        className="feature-container"
        background="transparent"
        padding="0"
        margin="0"
        borderRadius={0}
        gap="30px"
        // Mobile styles (column layout)
        mobileStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
        // Tablet styles (still column for small tablets)
        tabletStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
        // Laptop and Desktop styles (row layout)
        laptopStyles={{
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between",
          width: "100%",
        }}
        desktopStyles={{
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        {[
          {
            icon: "🎮",
            title: "Unlimited Games",
            desc: "Access thousands of games across multiple genres - from action to puzzle games.",
          },
          {
            icon: "🚫",
            title: "No Ads",
            desc: "Enjoy uninterrupted gaming without annoying ads popping up during gameplay.",
          },
          {
            icon: "✨",
            title: "Premium Content",
            desc: "Get exclusive access to premium games and content not available elsewhere.",
          },
        ].map((item, index) => (
          <Element
            canvas
            key={`feature_card_${index}`}
            id={`feature_card_${index}`}
            is={Container}
            className="feature-card"
            padding="30px"
            background="#f5f5f5"
            margin="0"
            borderRadius={10}
            width="100%"
            height="auto"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Text
              text={item.icon}
              fontSize={48}
              color="#1a1a2e"
              fontWeight="normal"
              textAlign="center"
              className="feature-icon"
              margin="0 0 20px 0"
              padding="0"
            />
            <Text
              text={item.title}
              fontSize={24}
              color="#1a1a2e"
              fontWeight="bold"
              textAlign="center"
              className="feature-title"
              margin="0 0 15px 0"
              padding="0"
            />
            <Text
              text={item.desc}
              fontSize={16}
              color="#333333"
              textAlign="center"
              className="feature-description"
              fontWeight="normal"
              margin="0"
              padding="0"
            />
          </Element>
        ))}
      </Element>
    </Element>
  );
};
